export const returnDateString = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("de-DE", {
    // you can use undefined as first argument
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const parseHourStr = (hourStr) => {
  return hourStr.replace(",", ":");
};

export const decimalHourToTime = (hourStr) => {
  let minutesDecimal = Math.round(
    parseFloat("." + hourStr.split(",")[1]) * 60
  ).toString();
  if (minutesDecimal.length == 1) minutesDecimal += "0";
  return hourStr.split(",")[0] + ":" + minutesDecimal;
};

// export const debugLog = (msg) => {
//     if(process.env.NODE_ENV == "development" || window.location.href.indexOf("8888") > 1) console.log(msg);
// }

export const debugLog = (function (undefined) {
  var Log = Error; // does this do anything?  proper inheritance...?
  Log.prototype.write = function (args) {
    var suffix = {
      "@": this.lineNumber
        ? this.fileName + ":" + this.lineNumber + ":1" // add arbitrary column value for chrome linking
        : extractLineNumberFromStack(this.stack),
    };

    args = args.concat([suffix]);
    // via @paulirish console wrapper
    if (console && console.log) {
      if (console.log.apply) {
        console.log.apply(console, args);
      } else {
        console.log(args);
      } // nicer display in some browsers
    }
  };
  var extractLineNumberFromStack = function (stack) {
    if (!stack) return "?"; // fix undefined issue reported by @sigod

    // correct line number according to how Log().write implemented
    var line = stack.split("\n")[2];
    // fix for various display text
    line =
      line.indexOf(" (") >= 0
        ? line.split(" (")[1].substring(0, line.length - 1)
        : line.split("at ")[1];
    return line;
  };

  return function (params) {
    if (
      process.env.NODE_ENV == "development" ||
      window.location.href.indexOf("8888") > 1
    )
      Log().write(Array.prototype.slice.call(arguments, 0));
  };
})();

